export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./calendar.vue?vue&type=template&id=ce485ea0&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/calendar.vue?vue&type=template&id=ce485ea0&
// module id = 1155
// module chunks = 0